import { createComponent } from '@carvana/merch-components';
import { PrimaryButton } from '@/common/Button';
import FireIcon from '~/icons/FireIcon';

export const LearnMoreContainer = createComponent('div', {
  className: 'mx-auto px-0 text-grey-3 tl-body-s'
});

export const ValuesContainer = createComponent('div', {
  className: 'flex flex-col bg-grey-1 p-40 m:flex-row'
});

export const ValueContainer = createComponent('div', {
  className: 'flex-1 text-center'
});

export const BorderedValueContainer = createComponent(ValueContainer, {
  className: 'border-b border-grey-2 m:border-b-0 m:border-r'
});

export const ValueLabel = createComponent('div', {
  className: 'tl-label-s'
});

export const Value = createComponent('div', {
  className: 'mt-24 text-blue-4 tl-header-m'
});

export const ValueDate = createComponent('div', {
  className: 'mt-4 tl-body-xs'
});

export const FAQLink = createComponent('a', {
  className: 'mt-8 text-blue-2 tl-link-s hover:text-blue-3'
});

export const BetterPrice = createComponent('div', {
  className: 'mx-auto mt-16 inline-block bg-white px-8 py-4 tl-body-xs'
});

export const Fire = createComponent(FireIcon, {
  className: 'h-[11px] w-[11px]'
});

export const CopyHeading = createComponent('div', {
  className: 'mt-40 text-center text-[18px] font-bold leading-[28px]'
});

export const CopyText = createComponent('p', {
  className: 'mt-8 text-center text-grey-5 tl-body-s'
});

export const Button = createComponent(PrimaryButton, {
  className: 'mx-auto mt-40 w-auto px-40'
});
